var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx:calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.66666 7.33203H6V8.66536H4.66666V7.33203ZM4.66666 9.9987H6V11.332H4.66666V9.9987ZM7.33333 7.33203H8.66666V8.66536H7.33333V7.33203ZM7.33333 9.9987H8.66666V11.332H7.33333V9.9987ZM10 7.33203H11.3333V8.66536H10V7.33203ZM10 9.9987H11.3333V11.332H10V9.9987Z",
    fill: "#0A3B70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.33333 14.6654H12.6667C13.402 14.6654 14 14.0674 14 13.332V3.9987C14 3.26336 13.402 2.66536 12.6667 2.66536H11.3333V1.33203H10V2.66536H6V1.33203H4.66667V2.66536H3.33333C2.598 2.66536 2 3.26336 2 3.9987V13.332C2 14.0674 2.598 14.6654 3.33333 14.6654ZM12.6667 5.33203L12.6673 13.332H3.33333V5.33203H12.6667Z",
    fill: "#0A3B70"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.848d2740927dd8d8ec4edb668fe603e8.svg";
export { ForwardRef as ReactComponent };